import styled from 'styled-components';

import MaterialIcon from '@/components/atom/MaterialIcon';
import Star from '@/components/atom/icon/doctor/Star';
import { LoadedDoctorDetailViewModel } from '@/components/templates/doctor/detail/useDoctorDetailViewModel';
import { DoctorReviewsViewModel } from '@/components/templates/doctor/detail/useDoctorReviewsViewModel';
import theme from '@/styles/theme';
import { formatPriceComma } from '@/utils/format';

interface Props {
  doctorDetailViewModel: LoadedDoctorDetailViewModel;
  doctorReviewsViewModel: DoctorReviewsViewModel;
}
const DoctorReviewAndDepartments = ({ doctorDetailViewModel, doctorReviewsViewModel }: Props) => {
  return (
    <Wrapper>
      <OperationTimeToggleRow>
        <DoctorStatusCol>
          {doctorReviewsViewModel.hasReview() && (
            <DoctorStatusRow>
              <RatingRow>
                <Star />
                <AverageRating>{doctorDetailViewModel.getDisplayAverageRating()}</AverageRating>
                <BorderLine />
                <ReviewCount onClick={doctorDetailViewModel.goToReview}>
                  {formatPriceComma(doctorReviewsViewModel.totalCount)}개 후기
                  <MaterialIcon name={'chevron_right'} size={16} color={theme.color.gray400} />
                </ReviewCount>
              </RatingRow>
            </DoctorStatusRow>
          )}
          <Tags>
            {doctorDetailViewModel.doctorDetail.doctor.departments.map((department) => (
              <Tag key={`department-${department.id}`} isProfessional={department.isProfessional}>
                {department.name}
                {department.isProfessional ? '전문의' : ''}
              </Tag>
            ))}
          </Tags>
        </DoctorStatusCol>
      </OperationTimeToggleRow>
    </Wrapper>
  );
};

export default DoctorReviewAndDepartments;

const Wrapper = styled.div`
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  display: block;
`;

const OperationTimeToggleRow = styled.div`
  display: flex;
  padding: 0px 4px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

const DoctorStatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
`;

const RatingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

const BorderLine = styled.div`
  width: 1px;
  height: 12px;
  background-color: ${theme.color.gray100};
  margin: 0 4px;
`;

const ReviewCount = styled.div`
  ${({ theme }) => `
    ${theme.typography.UI14M};
    color: ${theme.color.gray400};
  `}
  display: flex;
  align-items: center;
`;

const AverageRating = styled.div`
  ${({ theme }) => `
    ${theme.typography.UI14M};
    color: ${theme.color.gray700};
  `}
`;

const DoctorStatusCol = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Tags = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 4px;
  align-self: stretch;
  flex-wrap: wrap;
`;

const Tag = styled.div<{ isProfessional: boolean }>`
  display: flex;
  height: 20px;
  padding: 0px 4px;
  justify-content: center;
  align-items: center;
  gap: 3px;
  border-radius: 2px;

  ${({ theme, isProfessional }) => `
    ${theme.typography.UI12M};
    background: ${isProfessional ? theme.color.blue100 : theme.color.gray30};
    color: ${isProfessional ? theme.color.blue600 : theme.color.gray300};
  `}
`;
